import { render, staticRenderFns } from "./PrivacyPolicyBn.vue?vue&type=template&id=e534f0b6&scoped=true"
import script from "./PrivacyPolicyBn.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyBn.vue?vue&type=script&lang=ts"
import style0 from "./PrivacyPolicyBn.vue?vue&type=style&index=0&id=e534f0b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e534f0b6",
  null
  
)

export default component.exports